import ContributorSuggestionsPage from "@/features/change-requests/contributor-suggestions.page";
import { createFileRoute } from "@tanstack/react-router";

// CR-235 D8: the contributor's list of their own suggestions (guarded by the layout).
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/",
)({
  component: ContributorSuggestionsPage,
});
